import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { clientPlaceholder } from "../../../constants/attorney/lables";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import Loader from "../../Loader/Loader";
import { useGetGeoCodesZipCodeQuery } from "../../../slices/ssoManagementSlice";
import { validation } from "../../../constants/attorney/validationMessages";
import {
  phoneNumberRules,
  emailRules,
  zipRules,
  alphabetRules,
  indphonNumberRules,
  usphonNumberRules,
} from "../../../constants/regExp";
import {
  formType,
  witnessDefaultValue,
  witnessDefaultValue2,
} from "../../../constants/attorney/mockData";
import {
  attorney_uploadClientDocuments,
  client_uploadDocuments,
  veteran_uploadDocuments,
} from "../../../constants/routes";
import { useAddPeopleMutation } from "../../../slices/stackHolderApiManagmentSlice";
import {
  setStackHolderDetails,
  setWitnessors,
  setWitnessorlen,
  setWitnessorRemove,
} from "../../../slices/stackHolderSlice";
import { ReactComponent as DeleteIcon } from "../../../assets/images/DeleteAction.svg";
import PhoneInput from "react-phone-input-2";
import { ROLE } from "../../../constants/role";
import { optionalWitValidationMessage } from "../../../constants/client/labels";
import ModalPopupType2 from "../../modal/ModalPopupType2";
import utc from "dayjs/plugin/utc";
import { countryCodeList } from "../../../constants/labels";

dayjs.extend(utc);
function WitnessInformation({ onPrevious }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const today = dayjs();
  const yesterday = dayjs()
    .year(today.year() - 100)
    .startOf("year");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDate2, setSelectedDate2] = useState(null);
  const [cities, setCities] = useState([]);
  const [cities2, setCities2] = useState([]);
  const [zipCode, setZipCode] = useState("");
  const [zipCode2, setZipCode2] = useState("");
  const [existDate, setExistdata] = useState([]);
  const [showConfirmModal, setConfirmModal] = useState(false);
  const [locationState, setLocationState] = useState(null);
  const [submittedData, setSumbittedData] = useState(null);
  const buttonRef = useRef(null);
  const autofillHandled = useRef(false);
  const { stackHolders, witnessors, witnessorlen } = useSelector(
    (state) => state.stackholder
  );
  const { userInfo } = useSelector((state) => state.auth);
  const [countryCode, setCountryCode] = useState("");
  const [countryCode2, setCountryCode2] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumber2, setPhoneNumber2] = useState("");
  const [btnDisabled,setBtnDisabled] = useState(false);
  const stackCount = JSON.parse(sessionStorage.getItem("stackcount"));
  const [defaulvalue] = useState(
    (stackCount && stackCount?.DefaulWitness > 1) || witnessorlen > 1
        ? witnessDefaultValue2
        : witnessDefaultValue
    );
  const witnessorFormSchema = {
    firstName: yup
      .string()
      .trim()
      .required(`${validation.firstName.required}`)
      .matches(alphabetRules, `${validation.firstName.rule}`),
    lastName: yup
      .string()
      .trim()
      .required(`${validation.lastName.required}`)
      .matches(alphabetRules, `${validation.lastName.rule}`),
    addressLine1: yup
      .string()
      .trim()
      .required(`${validation.addressLine1.required}`),
    addressLine2: yup.string().trim(),
    dob: yup
      .string()
      .notRequired()
      .test("valid-date", "Invalid date of birth", (value) => {
        if (!value) return true;
        return !isNaN(Date.parse(value));
      })
      .test("max-date", "Date of birth cannot be in the future", (value) => {
        if (!value) return true;
        const newtoday = dayjs().utc();
        const dob = dayjs(value).utc();
        return dob <= newtoday;
        //  let newtoday = new Intl.DateTimeFormat('en-US').format(today);
        //   // console.log(today.toLocaleDateString())
        //   newtoday = dayjs(newtoday).utc()
        //   console.log(dayjs(newtoday).utc())

        // let newdob = new Intl.DateTimeFormat('en-US').format(dob);
        // newdob = dayjs(newdob).utc()
      })
      .test(
        "min-date",
        "Date of birth should be after January 1, 1924",
        (value) => {
          if (!value) return true;
          // const today = dayjs().utc();
          const minDate = dayjs().year(1924).startOf("year");
          const dob = dayjs(value).utc();
          return dob >= minDate;
        }
      ),
    phone: yup
      .string()
      .test(
        "phone-validation",
        `${validation.phone.phoneNumberRules}`,
        function (value, i) {
          if (i?.options?.index === 0) {
            if (countryCode) {
              if (countryCode === "+91") {
                return indphonNumberRules.test(value);
              } else if (countryCode === "+1") {
                return usphonNumberRules.test(value);
              } else {
                return phoneNumberRules.test(value);
              }
            }
          } else {
            if (countryCode2) {
              if (countryCode2 === "+91") {
                return indphonNumberRules.test(value);
              } else if (countryCode2 === "+1") {
                return usphonNumberRules.test(value);
              } else {
                return phoneNumberRules.test(value);
              }
            }
          }
        }
      )
      .required(`${validation.phone.phoneNumberRules}`),
    email: yup
      .string()
      .trim()
      .required(`${validation.email.required}`)
      .matches(emailRules, `${validation.email.emailRules}`),
    zip: yup
      .string()
      .trim()
      .matches(zipRules, { message: `${validation.zip.zipRules}` }),
    cityList: yup.mixed().when("city", {
      is: null,
      then: () =>
        yup
          .string()
          .notOneOf([""], `${validation.cityList.required}`)
          .required(),
      otherwise: (schema) => schema.notRequired(),
    }),
    city: yup.string().required(`${validation.city.required}`).nullable(),
    state: yup.string().required(`${validation.state.required}`),
    country: yup.string().required(`${validation.country.required}`),
  };
  const schema = yup.object().shape({
    witnessor: yup
      .array()
      .of(
        yup.lazy(() => {
          return yup.object().shape(witnessorFormSchema);
        })
      )
      .test({
        message: "The error message if length === 1",
        test: (arr) => arr.length < 3,
      }),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    setError,
    getValues,
    trigger
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    defaultValues: {
      witnessor: defaulvalue,
    },
  });
  const { fields, append, remove, insert } = useFieldArray({
    control,
    name: "witnessor",
  });
  const { data: geoCodeData, isLoading: geoCodeLoading } =
    useGetGeoCodesZipCodeQuery(zipCode, {
      skip: zipCode?.length !== 5,
    });
  const { data: geoCodeData2, isLoading: geoCodeLoading2 } =
    useGetGeoCodesZipCodeQuery(zipCode2, {
      skip: zipCode2?.length !== 5,
    });
  const [addPeople] = useAddPeopleMutation();
  const formatDate = (date) => {
    return dayjs(date).utc();
  };
  useEffect(() => {
    if (autofillHandled.current) return;
    if (phoneNumber && countryCode) {
      setValue(`witnessor.0.phone`, phoneNumber, {
        shouldValidate: true,
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (
      stackHolders?.witness &&
      stackHolders?.witness?.length === 0 &&
      (countryCode === "" || countryCode === undefined)
    ) {
      setCountryCode(witnessors["witnessor.0.countrycode"]);
    }
    if (phoneNumber2 && countryCode2) {
      setValue(`witnessor.1.phone`, phoneNumber2, {
        shouldValidate: true,
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (
      stackHolders?.witness &&
      stackHolders?.witness?.length === 0 &&
      (countryCode2 === "" || countryCode2 === undefined)
    ) {
      setCountryCode2(witnessors["witnessor.1.countrycode"]);
    }
     return () => {
    autofillHandled.current = true;
  };
  }, [
    phoneNumber,
    phoneNumber2,
    countryCode,
    countryCode2,
    setValue,
    stackHolders?.witness,
    witnessors,
  ]);

  useEffect(() => {
    const unsubscribe = toast.onChange((payload) => {
      if (payload.status === "removed") {
        setBtnDisabled(false);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const data = geoCodeData;
    if (data && data?.status === "OK") {
      let usResult = data?.results.find((result) => {
        let country = result.address_components.find((ac) =>
          ac.types.includes("country")
        )?.long_name;
        return (
          country === "United States" ||
          country === "Puerto Rico" ||
          country === "U.S. Virgin Islands" ||
          country === "American Samoa" ||
          country === "Northern Mariana Islands" ||
          country === "Guam"
        );
      });

      let multipleCities = usResult?.postcode_localities;

      let city = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("locality")
      )[0]?.long_name;

      let city1 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("sublocality")
      )[0]?.long_name;

      let city2 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("neighborhood")
      )[0]?.long_name;

      let city3 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_3")
      )[0]?.long_name;

      let city4 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_2")
      )[0]?.long_name;

      let state = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_1")
      )[0]?.long_name;

      let country = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("country")
      )[0]?.long_name;

      if (country === "United States") {
        let allCities = [
          city,
          city1,
          city2,
          city3,
          city4,
          ...(multipleCities || []).flatMap((city) =>
            city.split(",").map((c) => c.trim())
          ),
        ];

        allCities = allCities.filter(Boolean);

        allCities = [...new Set(allCities)];

        allCities.sort((a, b) => a.localeCompare(b));

        if (allCities && allCities?.length === 1) {
          setCities([]);
          const filteredCity = allCities[0];
          setValueZip(filteredCity, state, country, 0);
        } else if (allCities && allCities?.length > 0) {
          setCities(allCities);
          setValueZip(null, state, country, 0);
        } else {
          setCities([]);
          setValueZip("", "", "", 0);
          toast("Please provide the valid zip code");
        }
      }

      if (
        country === "Puerto Rico" ||
        country === "U.S. Virgin Islands" ||
        country === "American Samoa" ||
        country === "Northern Mariana Islands" ||
        country === "Guam"
      ) {
        let allCities = [
          city,
          city1,
          city2,
          city3,
          city4,
          state,
          ...(multipleCities || []).flatMap((city) =>
            city.split(",").map((c) => c.trim())
          ),
        ];

        allCities = allCities.filter(Boolean);

        allCities = [...new Set(allCities)];

        allCities.sort((a, b) => a.localeCompare(b));

        if (allCities && allCities?.length === 1) {
          setCities([]);
          const filteredCity = allCities[0];
          setValueZip(filteredCity, country, "United States", 0);
        } else if (allCities && allCities?.length > 0) {
          setCities(allCities);
          setValueZip(null, country, "United States", 0);
        } else {
          setCities([]);
          setValueZip("", "", "", 0);
          toast("Please provide the valid zip code");
        }
      }

      if (
        country !== "United States" &&
        country !== "Puerto Rico" &&
        country !== "U.S. Virgin Islands" &&
        country !== "Northern Mariana Islands" &&
        country !== "Guam" &&
        country !== "American Samoa"
      ) {
        toast("Please provide the US zip code");
        setCities([]);
        setValueZip("", "", "", 0);
      }
    } else {
      if (data !== undefined) {
        if (data && data?.status === "ZERO_RESULTS") {
          toast("Please provide the valid zip code");
          setCities([]);
          setValueZip("", "", "", 0);
        } else {
          data?.error_message
            ? toast(`${data?.error_message}`)
            : toast("somthing went wrong");
          setCities([]);
          setValueZip("", "", "", 0);
        }
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geoCodeData]);

  useEffect(() => {
    const data = geoCodeData2;
    if (data && data?.status === "OK") {
      let usResult = data?.results.find((result) => {
        let country = result.address_components.find((ac) =>
          ac.types.includes("country")
        )?.long_name;
        return (
          country === "United States" ||
          country === "Puerto Rico" ||
          country === "U.S. Virgin Islands" ||
          country === "American Samoa" ||
          country === "Northern Mariana Islands" ||
          country === "Guam"
        );
      });

      let multipleCities = usResult?.postcode_localities;

      let city = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("locality")
      )[0]?.long_name;

      let city1 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("sublocality")
      )[0]?.long_name;

      let city2 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("neighborhood")
      )[0]?.long_name;

      let city3 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_3")
      )[0]?.long_name;

      let city4 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_2")
      )[0]?.long_name;

      let state = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_1")
      )[0]?.long_name;

      let country = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("country")
      )[0]?.long_name;

      if (country === "United States") {
        let allCities = [
          city,
          city1,
          city2,
          city3,
          city4,
          ...(multipleCities || []).flatMap((city) =>
            city.split(",").map((c) => c.trim())
          ),
        ];

        allCities = allCities.filter(Boolean);

        allCities = [...new Set(allCities)];

        allCities.sort((a, b) => a.localeCompare(b));

        if (allCities && allCities?.length === 1) {
          setCities2([]);
          const filteredCity = allCities[0];
          setValueZip(filteredCity, state, country, 1);
        } else if (allCities && allCities?.length > 0) {
          setCities2(allCities);
          setValueZip(null, state, country, 1);
        } else {
          setCities2([]);
          setValueZip("", "", "", 1);
          toast("Please provide the valid zip code");
        }
      }

      if (
        country === "Puerto Rico" ||
        country === "U.S. Virgin Islands" ||
        country === "American Samoa" ||
        country === "Northern Mariana Islands" ||
        country === "Guam"
      ) {
        let allCities = [
          city,
          city1,
          city2,
          city3,
          city4,
          state,
          ...(multipleCities || []).flatMap((city) =>
            city.split(",").map((c) => c.trim())
          ),
        ];

        allCities = allCities.filter(Boolean);

        allCities = [...new Set(allCities)];

        allCities.sort((a, b) => a.localeCompare(b));

        if (allCities && allCities?.length === 1) {
          setCities2([]);
          const filteredCity = allCities[0];
          setValueZip(filteredCity, country, "United States", 1);
        } else if (allCities && allCities?.length > 0) {
          setCities2(allCities);
          setValueZip(null, country, "United States", 1);
        } else {
          setCities2([]);
          setValueZip("", "", "", 1);
          toast("Please provide the valid zip code");
        }
      }

      if (
        country !== "United States" &&
        country !== "Puerto Rico" &&
        country !== "U.S. Virgin Islands" &&
        country !== "Northern Mariana Islands" &&
        country !== "Guam" &&
        country !== "American Samoa"
      ) {
        toast("Please provide the US zip code");
        setCities2([]);
        setValueZip("", "", "", 1);
      }
    } else {
      if (data !== undefined) {
        if (data && data?.status === "ZERO_RESULTS") {
          toast("Please provide the valid zip code");
          setCities2([]);
          setValueZip("", "", "", 1);
        } else {
          data?.error_message
            ? toast(`${data?.error_message}`)
            : toast("somthing went wrong");
          setCities2([]);
          setValueZip("", "", "", 1);
        }
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geoCodeData2]);
  useEffect(() => {
    assignFieldValues("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stackHolders?.witness]);
  useEffect(() => {
    if (location?.state && location?.state?.user) {
      setLocationState(location);
    }
  }, [location]);

  useEffect(() => {
    if (!showConfirmModal) {
      setBtnDisabled(false);
    }
  }, [showConfirmModal])

  const assignFieldValues = (rem) => {
    if (stackHolders?.witness && stackHolders?.witness?.length > 0) {
      let temoExistExecutors = [];
      stackHolders?.witness?.forEach((ele, i) => {
        let fname =
        witnessors?.[`witnessor.${i}.firstName`]
        && witnessors?.[`witnessor.${i}.firstName`] !== ""
        ?
        witnessors?.[`witnessor.${i}.firstName`]:
        ele?.firstName && ele?.firstName !== ""
            ? ele?.firstName
            : "";
        let lname =
        witnessors?.[`witnessor.${i}.lastName`] && witnessors?.[`witnessor.${i}.lastName`] !==""
        ?witnessors?.[`witnessor.${i}.lastName`]
         : ele?.lastName !== ""
            ? ele?.lastName
            : "";
        let email =
          ele?.emailId && ele?.emailId !== ""
            ? ele?.emailId
            : witnessors?.[`witnessor.${i}.email`];
        let dob =
        witnessors?.[`witnessor.${i}.dob`] && witnessors?.[`witnessor.${i}.dob`]!=="" ? witnessors?.[`witnessor.${i}.dob`] : ele?.dob;
        // let driversLicense= ele.driversLicense !== ""?ele.driversLicense: witnessors[`witnessor.${i}.driversLicense`];
        let addressLine1 =
          ele?.address?.addressLine1 && ele?.address?.addressLine1 !== ""
            ? ele?.address?.addressLine1
            : witnessors?.[`witnessor.${i}.addressLine1`];
        let addressLine2 =
          ele?.address?.addressLine2 && ele?.address?.addressLine2 !== ""
            ? ele?.address?.addressLine2
            : witnessors?.[`witnessor.${i}.addressLine2`];
        let zip =
          witnessors?.[`witnessor.${i}.zip`] &&
          witnessors?.[`witnessor.${i}.zip`] !== ""
            ? witnessors?.[`witnessor.${i}.zip`]
            : ele?.address?.zip;
        let city =
          witnessors?.[`witnessor.${i}.city`] &&
          witnessors?.[`witnessor.${i}.city`] !== ""
            ? witnessors?.[`witnessor.${i}.city`]
            : ele?.address?.city;
        //let cityList= witnessors?.[`witnessor.${i}.cityList`] && witnessors?.[`witnessor.${i}.cityList`] !== ""?witnessors?.[`witnessor.${i}.cityList`]:"";
        let cityList =
          witnessors?.[`witnessor.${i}.cityList`] &&
          witnessors?.[`witnessor.${i}.cityList`] !== ""
            ? witnessors?.[`witnessor.${i}.cityList`]
            : ele?.address?.cityList;
        let state =
          witnessors?.[`witnessor.${i}.state`] &&
          witnessors?.[`witnessor.${i}.state`] !== ""
            ? witnessors?.[`witnessor.${i}.state`]
            : ele?.address?.state;
        let country =
          witnessors?.[`witnessor.${i}.country`] &&
          witnessors?.[`witnessor.${i}.country`] !== ""
            ? witnessors?.[`witnessor.${i}.country`]
            : ele?.address?.country;
        let phone =
          ele?.phoneNumber && ele?.phoneNumber !== ""
            ? ele?.phoneNumber
            : witnessors?.[`witnessor.${i}.phone`];
        let countryCod =
          ele?.countryCode && ele?.countryCode !== ""
            ? ele?.countryCode
            : witnessors?.[`witnessor.${i}.countrycode`];
          if (!email && (ele?.email && ele?.email !== "")) {
            email = ele?.email;
          }    
        setValue(`witnessor.${i}.firstName`, fname, {
          shouldValidate: false,
          shouldTouch: true,
          shouldDirty: true,
        });
        setValue(`witnessor.${i}.lastName`, lname, {
          shouldValidate: false,
          shouldTouch: true,
          shouldDirty: true,
        });
        setValue(`witnessor.${i}.email`, email, {
          shouldValidate: false,
          shouldTouch: true,
          shouldDirty: true,
        });
        if (phone && phone !== "") {
          let tempPhone = phone;
            if (phone.includes("+")) {
              let count = phone.split("").filter((ele) => ele === "+").length;

              tempPhone = phone.substring(count);
            }
            const cleanValue = tempPhone.replace(/[^0-9]/g, "");
            let prefix = cleanValue.slice(0, -10);
            if(prefix === "1" || prefix === "91"){
            if(tempPhone.length===10){
              tempPhone="1"+tempPhone;
              if(!(countryCod && countryCod !== "")){
                i === 0 ? setCountryCode("+1") : setCountryCode2("+1");
              }
             }
             if(!(countryCod && countryCod !== "") && phone.startsWith("+1")){
              i === 0 ? setCountryCode("+1") : setCountryCode2("+1");
             }
             if(!(countryCod && countryCod !== "") && phone.startsWith("+91")){
              i === 0 ? setCountryCode("+91") : setCountryCode2("+91");
             }
          i === 0 ? setPhoneNumber(tempPhone) : setPhoneNumber2(tempPhone);
            setValue(`witnessor.${i}.phone`, cleanValue, {
              shouldValidate: false,
              shouldTouch: true,
              shouldDirty: true,
            });
          }
          else {
            setValue(`witnessor.${i}.phone`, "", {
              shouldValidate: false,
              shouldTouch: true,
              shouldDirty: false,
            });
          }
        }
        else {
            setValue(`witnessor.${i}.phone`, "", {
              shouldValidate: false,
              shouldTouch: true,
              shouldDirty: false,
            });
          }
        if (countryCod && countryCod !== "") {
          i === 0 ? setCountryCode(countryCod) : setCountryCode2(countryCod);
        }
        if (dob && dob !== null && dob !== "") {
          i === 0
            ? setSelectedDate(dayjs(dob).format("YYYY-MM-DD"))
            : setSelectedDate2(dayjs(dob).format("YYYY-MM-DD"));
          setValue(`witnessor.${i}.dob`, dayjs(dob).format("YYYY-MM-DD"));
        }

        setValue(`witnessor.${i}.addressLine1`, addressLine1, {
          shouldValidate: false,
          shouldTouch: true,
          shouldDirty: true,
        });
        setValue(`witnessor.${i}.addressLine2`, addressLine2, {
          shouldValidate: false,
          shouldTouch: true,
          shouldDirty: true,
        });
        zip && setValue(`witnessor.${i}.zip`, zip, {
          shouldValidate: false,
          shouldTouch: true,
          shouldDirty: true,
        });
        if (city && city !== null && city !== "") {
          setValue(`witnessor.${i}.city`, city, {
            shouldValidate: false,
            shouldTouch: true,
            shouldDirty: true,
          });
        }
        if (
          !(city && city === null && city !== "") &&
          cityList &&
          cityList !== null &&
          cityList !== ""
        ) {
          setValue(`witnessor.${i}.city`, cityList, {
            shouldValidate: false,
            shouldTouch: true,
            shouldDirty: true,
          });
        }
        setValue(`witnessor.${i}.state`, state, {
          shouldValidate: false,
          shouldTouch: true,
          shouldDirty: true,
        });
        setValue(`witnessor.${i}.country`, country, {
          shouldValidate: false,
          shouldTouch: true,
          shouldDirty: true,
        });
        let tempEx = {
          firstName: fname,
          lastName: lname,
          name: fname + " " + lname,
          emailId: email,
          phoneNumber: phoneNumber,
          dateOfBirth: dayjs(dob).format("YYYY-MM-DD"),
          address: {
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            zip: zip,
            city: city === null ? cityList : city,
            state: state,
            country: country,
          },
        };
        temoExistExecutors.push(tempEx);
      });
      setExistdata(temoExistExecutors);
    }
    if (
      ((stackHolders?.witness && stackHolders?.witness.length === 0) ||
        !stackHolders?.witness) &&
      Object.keys(witnessors).length > 0
    ) {
      
      if (rem !== "remove") {
        fields.forEach((ele, i) => {
          let city = witnessors?.[`witnessor.${i}.city`];
          let cityList = witnessors?.[`witnessor.${i}.cityList`]
          setValue(
            `witnessor.${i}.firstName`,
            witnessors?.[`witnessor.${i}.firstName`],
            {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            }
          );
          setValue(
            `witnessor.${i}.lastName`,
            witnessors?.[`witnessor.${i}.lastName`],
            {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            }
          );
          setValue(
            `witnessor.${i}.email`,
            witnessors?.[`witnessor.${i}.email`],
            {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            }
          );
          setValue(
            `witnessor.${i}.phone`,
            witnessors?.[`witnessor.${i}.phone`],
            {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            }
          );
          i === 0
            ? setPhoneNumber(witnessors?.[`witnessor.${i}.phone`])
            : setPhoneNumber2(witnessors?.[`witnessor.${i}.phone`]);
          if (ele?.dateOfBirth && ele.dateOfBirth !== null) {
            i === 0
              ? setSelectedDate(formatDate(witnessors?.[`witnessor.${i}.dob`]))
              : setSelectedDate2(
                  formatDate(witnessors?.[`witnessor.${i}.dob`])
                );
          }

          // setValue(
          //   `witnessor.${i}.dob`,
          //   formatDate(witnessors?.[`witnessor.${i}.dob`])
          // );
          setValue(
            `witnessor.${i}.addressLine1`,
            witnessors?.[`witnessor.${i}.addressLine1`],
            {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            }
          );
          setValue(
            `witnessor.${i}.addressLine2`,
            witnessors?.[`witnessor.${i}.addressLine2`],
            {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            }
          );
          setValue(`witnessor.${i}.zip`, witnessors?.[`witnessor.${i}.zip`], {
            shouldValidate: true,
            shouldTouch: true,
            shouldDirty: true,
          });
          if (city && city !== null && city !== "") {
            setValue(`witnessor.${i}.city`, city, {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            });
          }
          if (
            !(city && city === null && city !== "") &&
            cityList &&
            cityList !== null &&
            cityList !== ""
          ) {
            setValue(`witnessor.${i}.city`, cityList, {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            });
          }
          setValue(
            `witnessor.${i}.state`,
            witnessors?.[`witnessor.${i}.state`],
            {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            }
          );
          setValue(
            `witnessor.${i}.country`,
            witnessors?.[`witnessor.${i}.country`],
            {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            }
          );
          if (
            witnessors?.[`witnessor.${i}.dob`] !== undefined &&
            witnessors?.[`witnessor.${i}.dob`] !== null
          ) {
            handleDateChange(witnessors?.[`witnessor.${i}.dob`], i);
          }
        });
      } else {
        fields
          .filter((e, i) => i === 0)
          .forEach((ele, i) => {
            let city = witnessors?.[`witnessor.${i}.city`];
            let cityList = witnessors?.[`witnessor.${i}.cityList`];
            setValue(
              `witnessor.${i}.firstName`,
              witnessors?.[`witnessor.${i}.firstName`],
              {
                shouldValidate: true,
                shouldTouch: true,
                shouldDirty: true,
              }
            );
            setValue(
              `witnessor.${i}.lastName`,
              witnessors?.[`witnessor.${i}.lastName`],
              {
                shouldValidate: true,
                shouldTouch: true,
                shouldDirty: true,
              }
            );
            setValue(
              `witnessor.${i}.email`,
              witnessors?.[`witnessor.${i}.email`],
              {
                shouldValidate: true,
                shouldTouch: true,
                shouldDirty: true,
              }
            );
            setValue(
              `witnessor.${i}.phone`,
              witnessors?.[`witnessor.${i}.phone`],
              {
                shouldValidate: true,
                shouldTouch: true,
                shouldDirty: true,
              }
            );
            i === 0
              ? setPhoneNumber(witnessors?.[`witnessor.${i}.phone`])
              : setPhoneNumber2(witnessors?.[`witnessor.${i}.phone`]);
            if (
              witnessors?.[`witnessor.${i}.dob`] !== undefined &&
              witnessors?.[`witnessor.${i}.dob`] !== null
            ) {
              i === 0
                ? setSelectedDate(
                    formatDate(witnessors?.[`witnessor.${i}.dob`])
                  )
                : setSelectedDate2(
                    formatDate(witnessors?.[`witnessor.${i}.dob`])
                  );
            }
            setValue(
              `witnessor.${i}.addressLine1`,
              witnessors?.[`witnessor.${i}.addressLine1`],
              {
                shouldValidate: true,
                shouldTouch: true,
                shouldDirty: true,
              }
            );
            setValue(
              `witnessor.${i}.addressLine2`,
              witnessors?.[`witnessor.${i}.addressLine2`],
              {
                shouldValidate: true,
                shouldTouch: true,
                shouldDirty: true,
              }
            );
            setValue(`witnessor.${i}.zip`, witnessors?.[`witnessor.${i}.zip`], {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            });
            if (city && city !== null && city !== "") {
              setValue(`witnessor.${i}.city`, city, {
                shouldValidate: true,
                shouldTouch: true,
                shouldDirty: true,
              });
            }
            if (
              !(city && city === null && city !== "") &&
              cityList &&
              cityList !== null &&
              cityList !== ""
            ) {
              setValue(`witnessor.${i}.city`, cityList, {
                shouldValidate: true,
                shouldTouch: true,
                shouldDirty: true,
              });
            }
            setValue(
              `witnessor.${i}.state`,
              witnessors?.[`witnessor.${i}.state`],
              {
                shouldValidate: true,
                shouldTouch: true,
                shouldDirty: true,
              }
            );
            setValue(
              `witnessor.${i}.country`,
              witnessors?.[`witnessor.${i}.country`],
              {
                shouldValidate: true,
                shouldTouch: true,
                shouldDirty: true,
              }
            );
            if (
              witnessors?.[`witnessor.${i}.dob`] !== undefined &&
              witnessors?.[`witnessor.${i}.dob`] !== null
            ) {
              handleDateChange(witnessors?.[`witnessor.${i}.dob`], i);
            }
            //handleDateChange(witnessors?.[`witnessor.${i}.dob`],i)
          });
      }
    }
  };
  const removeMoreWitnessor = async (i) => {
    //setFieldEmpty(true);
    const { ...rest } = Object.fromEntries(
      Object.entries(witnessors).filter(([key]) => !key.includes(".1."))
    );
    remove(2);
    remove(1);
    assignFieldValues("remove");
    dispatch(setWitnessorRemove({ len: 1, witness: rest }));
    setSelectedDate2(null);
    setCountryCode2("");
    setPhoneNumber2("");
  };
  const setValueZip = (city, state, country, index) => {
    setValue(`witnessor.${index}.city`, city, {
      shouldValidate: true,
      shouldTouch: true,
      shouldDirty: true,
    });

    setValue(`witnessor.${index}.state`, state, {
      shouldValidate: true,
      shouldTouch: true,
      shouldDirty: true,
    });

    setValue(`witnessor.${index}.country`, country, {
      shouldValidate: true,
      shouldTouch: true,
      shouldDirty: true,
    });
    let temp =
      index === 0
        ? {
            "witnessor.0.city": city,
            "witnessor.0.state": state,
            "witnessor.0.country": country,
          }
        : {
            "witnessor.1.city": city,
            "witnessor.1.state": state,
            "witnessor.1.country": country,
          };
    dispatch(setWitnessors({ ...witnessors, ...temp }));
  };
  const onConfirm = async ({ data, witnessorList, edited }) => {
    try {
      if (edited === true) {
        const res = await addPeople(data).unwrap();
        if (res.isSuccessful) {
          toast.success(res?.message);
          dispatch(
            setStackHolderDetails({
              ...stackHolders,
              witness: [...witnessorList],
            })
          );
          //onNext();
          if (userInfo?.role === ROLE.client) {
            navigate(client_uploadDocuments, {
              state: {
                doc: locationState?.state?.doc,
                user: locationState?.state?.user,
              },
            });
          } 

          if (userInfo?.role === ROLE.attorney){
            navigate(attorney_uploadClientDocuments, {
              state: {
                doc: locationState?.state?.doc,
                user: locationState?.state?.user,
              },
            });
          }

          if (userInfo?.role === ROLE.individualClient && userInfo?.specialUser){
            navigate(veteran_uploadDocuments, {
              state: {
                doc: locationState?.state?.doc,
                user: locationState?.state?.user,
              },
            });
          }
        } else {
          toast.error(res?.message);
        }
      } else {
        //onNext();
      }
    } catch (err) {
      toast.error(err?.data?.errorMessage || err.errorMessage);
    }
  };
  const onSubmit = async (formData) => {
    setBtnDisabled(true);
    let witnessorList = [];
    let dataChangeList = [];
    let nonMandatoryFields = false;
    formData?.witnessor?.forEach((ele, i) => {
      let temp = {
        firstName: ele.firstName,
        lastName: ele.lastName,
        name: ele.firstName + " " + ele.lastName,
        emailId: ele.email,
        phoneNumber: `+${ele.phone}`,
        drivingLicense: "",
        dateOfBirth:
          i === 0
            ? selectedDate === "Invalid Date" || selectedDate === null
              ? ""
              : dayjs(selectedDate).format("YYYY-MM-DD")
            : selectedDate2 === "Invalid Date" || selectedDate2 === null
            ? ""
            : dayjs(selectedDate2).format("YYYY-MM-DD"),
        address: {
          addressLine1: ele.addressLine1,
          addressLine2: ele.addressLine2 || "",
          zip: ele.zip,
          city: ele.city !== null ? ele.city : ele.cityList,
          state: ele.state,
          country: ele.country,
        },
      };
      let existEx = {
        ...temp,
        dateOfBirth:
          i === 0
            ? selectedDate === "Invalid Date" || selectedDate === null
              ? ""
              : dayjs(selectedDate).format("YYYY-MM-DD")
            : selectedDate2 === "Invalid Date" || selectedDate2 === null
            ? ""
            : dayjs(selectedDate2).format("YYYY-MM-DD"),
      };
      witnessorList.push(temp);
      dataChangeList.push(existEx);
      if (i === 0) {
        nonMandatoryFields =
          (selectedDate === undefined || selectedDate === null) && true;
      }
      if (i === 1) {
        nonMandatoryFields =
          (selectedDate2 === undefined || selectedDate2 === null) && true;
      }
    });
    const transformData = {
      clientId: location?.state?.user?.clientId,
      userId: userInfo?.userId,
      type: formType.witness,
      witness: witnessorList,
    };
    if (witnessorList.length > 1) {
      let errorMessage = "Witness 1 and Witness 2 cannot have the same";
      let isFieldSame = false;
      let emailMessage = "";
      let phoneMessage = "";
      if (String(witnessorList[0]?.emailId).toLowerCase() === String(witnessorList[1]?.emailId).toLowerCase()) {
        emailMessage = " Email";
        isFieldSame = true;
      }
      if (witnessorList[0]?.phoneNumber === witnessorList[1]?.phoneNumber) {
        isFieldSame = true;
        phoneMessage =
          emailMessage === "" ? " Mobile phone" : " and Mobile phone";
      }
      if (isFieldSame) {
        toast.error(errorMessage + emailMessage + phoneMessage);
        return;
      }
    }
    const data = JSON.stringify(transformData);
    const submitDataJson = JSON.stringify(dataChangeList);
    const existDataJson = JSON.stringify(existDate);
    let edited = submitDataJson !== existDataJson ? true : false;
    if (nonMandatoryFields) {
      setSumbittedData({
        data,
        witnessorList,
        edited,
      });
      setConfirmModal(true);
    } else {
      onConfirm({
        data,
        witnessorList,
        edited,
      });
    }
  };
  const handleDateChange = (date, i) => {
    // const adjustedDate = new Date(date);
    // adjustedDate.setHours(0, 0, 0, 0);
    // const onSelectDate = adjustedDate.toDateString();
    if (date === null) {
      i === 0 ? setSelectedDate(null) : setSelectedDate2(null);
      setValue(`witnessor.${i}.dob`, null, { shouldValidate: true });
      let dobField =
        i === 0 ? { "witnessor.0.dob": date } : { "witnessor.1.dob": date };
      dispatch(setWitnessors({ ...witnessors, ...dobField }));
    } else {
      const formattedDate = dayjs(date).format("YYYY-MM-DD");
      i === 0
        ? setSelectedDate(formattedDate)
        : setSelectedDate2(formattedDate);
      setValue(`witnessor.${i}.dob`, formattedDate, { shouldValidate: true });
      // eslint-disable-next-line no-unused-vars
      let dobField =
        i === 0 ? { "witnessor.0.dob": date } : { "witnessor.1.dob": date };
      dispatch(setWitnessors({ ...witnessors, ...dobField }));
    }
  };
  const handleKeyDown = (event, i) => {
    if (event.key === "Backspace" || event.key === "Delete") {
      setTimeout(() => {
        i === 0 ? setSelectedDate(null) : setSelectedDate2(null);
        setValue(`witnessor.${i}.dob`, null, { shouldValidate: true });
        let dobField =
          i === 0 ? { "witnessor.0.dob": null } : { "witnessor.1.dob": null };
        dispatch(setWitnessors({ ...witnessors, ...dobField }));
      }, 0);
    }
  };
  const handleMaxNumber = (event, i) => {
    let { value, name } = event.target;
    if (name === `witnessor.${i}.phone`) {
      event.target.value = value.slice(0, 10);
    }
    if (name === `witnessor.${i}.zip`) {
      event.target.value = value.slice(0, 5);
      i === 0
        ? setZipCode(event.target.value)
        : setZipCode2(event.target.value);
    }
  };
  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const numericRegex = /^[0-9\b]+$/;
    const isNumericKey = numericRegex.test(keyValue);
    const isNumericKeypad = keyCode >= 96 && keyCode <= 105;
    const isTabKey = keyCode === 9;

    if (!(isNumericKey || isNumericKeypad || isTabKey)) {
      event.preventDefault();
    }
  };
  const addMoreWitnessor = () => {
    if (stackHolders?.witness?.length > 0) {
      insert(1, {
        firstName: "",
        lastName: "",
        addressLine1: "",
        addressLine2: "",
        dob: "",
        phone: "",
        email: "",
        zip: "",
        city: "",
        state: "",
        country: "",
      });
    } else {
      append({
        firstName: "",
        lastName: "",
        addressLine1: "",
        addressLine2: "",
        dob: "",
        phone: "",
        email: "",
        zip: "",
        city: "",
        state: "",
        country: "",
      });
    }
    dispatch(setWitnessorlen(2));
    remove(2);
  };
  const handleChangeField = (e) => {
    dispatch(setWitnessors({ ...witnessors, [e.target.name]: e.target.value }));
    if((e.target.name === "witnessor.1.zip") || (e.target.name === "witnessor.0.zip") ){
      if(e.target.value.length===5){
        setError(e.target.name, null)
      }
    }
  };
  const handlePhone = (value, phone, i) => {
    let countrycode = "";
    if (i === 0) {
      setPhoneNumber(value);
      if (phone.dialCode === "1" && phone.countryCode === "us") {
        setCountryCode("+1");
        countrycode = "+1";
      }
      if (phone.dialCode === "91" && phone.countryCode === "in") {
        setCountryCode("+91");
        countrycode = "+91";
      }
    } else {
      setPhoneNumber2(value);
      if (phone.dialCode === "1" && phone.countryCode === "us") {
        setCountryCode2("+1");
        countrycode = "+1";
      }
      if (phone.dialCode === "91" && phone.countryCode === "in") {
        setCountryCode2("+91");
        countrycode = "+91";
      }
      setValue(`witnessor.${i}.phone`, value, { shouldValidate: true });
    }

    dispatch(
      setWitnessors({
        ...witnessors,
        [i === 0 ? "witnessor.0.phone" : "witnessor.1.phone"]: value,
        [i === 0 ? "witnessor.0.countrycode" : "witnessor.1.countrycode"]:
          countrycode,
      })
    );
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Force sync DOM values to RHF state
    document.querySelectorAll("input[autocomplete]").forEach((input) => {
      const val = input.value?.trim();
      if (val && !getValues(input.name)) {
        setValue(input.name, val, { shouldValidate: true });
        console.log("Synced autofill before validation:", input.name, val);
      }
    });
    // Trigger validation manually after syncing
    const isValid = await trigger();
    if (!isValid) return; // stop if still invalid

    // Now call the original onSubmit
    handleSubmit(onSubmit)();
  };
  return (
    <>
      <Form
        className="custom-form px-2 pb-3 type-2"
        onSubmit={handleFormSubmit}
      >
        {fields.map((item, i) => {
          let citiesArray = i === 0 ? cities : cities2;
          let selectedDates =
            i === 0
              ? dayjs(selectedDate).isValid()
                ? dayjs(selectedDate)
                : null
              : dayjs(selectedDate2).isValid()
              ? dayjs(selectedDate2)
              : null;
          return (
            <div className="executor-form position-relative" key={item.id}>
              <div className="">
                <Row className={i === 0 ? "" : "mt-4"}>
                  <Col lg={12} md={12} className="mt-4">
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor={`witnessor.${i}.firstName`}
                            className="required mb-0"
                          >
                            {clientPlaceholder.firstName}
                          </Form.Label>
                          <Form.Control
                            className="form-input"
                            type="text"
                            name={`witnessor.${i}.firstName`}
                            autoComplete="off"
                            maxLength={30}
                            {...register(`witnessor.${i}.firstName`)}
                            isInvalid={!!errors?.witnessor?.[i]?.firstName}
                            data-testid={`witnessor.${i}.firstName`}
                            id={`witnessor.${i}.firstName`}
                            onChange={handleChangeField}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors?.witnessor?.[i]?.firstName?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor={`witnessor.${i}.lastName`}
                            className="required mb-0"
                          >
                            {clientPlaceholder.lastName}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            name={`witnessor.${i}.lastName`}
                            maxLength={30}
                            autoComplete="off"
                            {...register(`witnessor.${i}.lastName`)}
                            isInvalid={!!errors?.witnessor?.[i]?.lastName}
                            data-testid={`witnessor.${i}.lastName`}
                            id={`witnessor.${i}.lastName`}
                            onChange={handleChangeField}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors?.witnessor?.[i]?.lastName?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor={`witnessor.${i}.email`}
                            className="required mb-0"
                          >
                            {clientPlaceholder.email}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="email"
                            name="email"
                            autoComplete="off"
                            {...register(`witnessor.${i}.email`)}
                            isInvalid={!!errors?.witnessor?.[i]?.email}
                            data-testid={`witnessor.${i}.email`}
                            onBlur={(e) => {
                              const trimmed = (e.target.value || "").trim();
                              setValue("email", trimmed, {
                                shouldValidate: true,
                                shouldTouch: true,
                                  shouldDirty: true,
                              });
                              handleChangeField(e);
                            }}
                            id={`witnessor.${i}.email`}
                            //onChange={handleChangeField}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors?.witnessor?.[i]?.email?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor={`witnessor.${i}.phone`}
                            className="required mb-0"
                          >
                            {clientPlaceholder.phone}
                          </Form.Label>
                          <Controller
                            control={control}
                            name={`witnessor.${i}.phone`}
                            render={({ field }) => (
                              <div
                                className={
                                  errors?.witnessor?.[i]?.phone
                                    ? "phone-input-invalid-container"
                                    : ""
                                }
                              >
                                <PhoneInput
                                  {...field}
                                  defaultCountry="us"
                                  onlyCountries={countryCodeList}
                                  placeholder=""
                                  title=""
                                  country={"us"}
                                  inputProps={{
                                    required: true,
                                    autoFocus: false,
                                    title: "",
                                  }}
                                  value={i === 0 ? phoneNumber : phoneNumber2}
                                  countryCodeEditable={false}
                                  onChangeCapture={handleMaxNumber}
                                  onChange={(value, country) => {
                                    field.onChange(value);
                                    handlePhone(value, country, i);
                                  }}
                                />
                              </div>
                            )}
                          />
                            <Form.Control
                            className="form-input input-border-radius-unset input_number"
                            type="hidden"
                            name={`witnessor.${i}.phone`}
                            onKeyDown={handleKeyPress}
                            onChangeCapture={(e) => handleMaxNumber(e, i)}
                            autoComplete="off"
                            {...register(`witnessor.${i}.phone`)}
                            isInvalid={!!errors?.witnessor?.[i]?.phone}
                            data-testid={`witnessor.${i}.phone`}
                            id={`witnessor.${i}.phone`}
                            onChange={handleChangeField}
                            value={i === 0 ? phoneNumber : phoneNumber2}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors?.witnessor?.[i]?.phone?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="" className="mb-0">
                        {clientPlaceholder.dob}
                      </Form.Label>
                      <Controller
                        name={`witnessor.${i}.dob`}
                        control={control}
                        render={({ field }) => (
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <div
                              className={
                                errors?.witnessor?.[i]?.dob
                                  ? "mui-date-picker-invalid-container"
                                  : "mui-date-picker-container"
                              }
                            >
                              <DesktopDatePicker
                                name={`witnessor.${i}.dob`}
                                type="date"
                                value={selectedDates}
                                slotProps={{
                                  field: { clearable: true },
                                  textField: {
                                    onKeyDown: (e) => handleKeyDown(e, i),
                                  },
                                }}
                                onChange={(e) => handleDateChange(e, i)}
                                maxDate={today}
                                minDate={yesterday}
                                data-test={`witnessor.${i}.dob`}
                              />
                            </div>
                          </LocalizationProvider>
                        )}
                      />
                      <Form.Control
                        type="hidden"
                        value={selectedDates || ""}
                        autoComplete="off"
                        {...register(`witnessor.${i}.dob`, {
                          required: true,
                        })}
                        isInvalid={!!errors?.witnessor?.[i]?.dob}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.witnessor?.[i]?.dob?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        htmlFor={`witnessor.${i}.addressLine1`}
                        className="required mb-0"
                      >
                        {clientPlaceholder.addressLine1}
                      </Form.Label>
                      <Form.Control
                        className="form-input input-border-radius-unset"
                        type="text"
                        name={`witnessor.${i}.addressLine1`}
                        maxLength={255}
                        autoComplete="off"
                        {...register(`witnessor.${i}.addressLine1`)}
                        isInvalid={!!errors?.witnessor?.[i]?.addressLine1}
                        data-testid={`witnessor.${i}.addressLine1`}
                        id={`witnessor.${i}.addressLine1`}
                        onChange={handleChangeField}
                      />
                      <Form.Control.Feedback
                        data-testid="invalid-feedback"
                        type="invalid"
                      >
                        {errors?.witnessor?.[i]?.addressLine1?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        htmlFor={`witnessor.${i}.addressLine2`}
                        className="form-label mb-0"
                      >
                        {clientPlaceholder.addressLine2}
                      </Form.Label>
                      <Form.Control
                        className="form-input input-border-radius-unset"
                        type="text"
                        name={`witnessor.${i}.addressLine2`}
                        maxLength={255}
                        autoComplete="off"
                        {...register(`witnessor.${i}.addressLine2`)}
                        isInvalid={!!errors?.witnessor?.[i]?.addressLine2}
                        data-testid={`witnessor.${i}.addressLine2`}
                        id={`witnessor.${i}.addressLine2`}
                        onChange={handleChangeField}
                      />
                      <Form.Control.Feedback
                        data-testid="invalid-feedback"
                        type="invalid"
                      >
                        {errors?.witnessor?.[i]?.addressLine2?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        htmlFor={`witnessor.${i}.zip`}
                        className="required mb-0"
                      >
                        {clientPlaceholder.zip}
                      </Form.Label>
                      <Form.Control
                        className="form-input input-border-radius-unset input_number"
                        type="number"
                        name={`witnessor.${i}.zip`}
                        autoComplete="off"
                        onKeyDown={handleKeyPress}
                        onChangeCapture={(e) => handleMaxNumber(e, i)}
                        {...register(`witnessor.${i}.zip`)}
                        isInvalid={
                          Object.keys(witnessors).length>0 && witnessors?.[`witnessor.${i}.zip`]?
                        witnessors?.[`witnessor.${i}.zip`].length<5?true:false
                      :!!errors?.witnessor?.[i]?.zip}
                        data-testid={`witnessor.${i}.zip`}
                        id={`witnessor.${i}.zip`}
                        onChange={handleChangeField}
                      />
                      <Form.Control.Feedback
                        data-testid="invalid-feedback"
                        type="invalid"
                      >
                        {errors?.witnessor?.[i]?.zip?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        htmlFor={`witnessor.${i}.city`}
                        className="required mb-0"
                      >
                        {clientPlaceholder.cityList}
                      </Form.Label>
                      {citiesArray?.length > 0 && (
                        <>
                          <Form.Select
                            aria-label="Default select example"
                            className="form-input input-border-radius-unset select-placeholder"
                            name={`witnessor.${i}.city`}
                            isInvalid={!!errors?.witnessor?.[i]?.cityList}
                            {...register(`witnessor.${i}.cityList`)}
                            id={`witnessor.${i}.city`}
                            data-testid={`witnessor.${i}.city`}
                            onChange={handleChangeField}
                          >
                            <option value="" hidden></option>
                            {citiesArray?.length > 0 &&
                              citiesArray.map((item) => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                          </Form.Select>
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors?.witnessor?.[i]?.cityList?.message}
                          </Form.Control.Feedback>
                        </>
                      )}
                      {citiesArray?.length === 0 && (
                        <>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            // name="city"
                            autoComplete="off"
                            {...register(`witnessor.${i}.city`)}
                            isInvalid={!!errors?.witnessor?.[i]?.city}
                            disabled
                            data-testid={`witnessor.${i}.city`}
                            id={`witnessor.${i}.city`}
                            onChange={handleChangeField}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors?.witnessor?.[i]?.city?.message}
                          </Form.Control.Feedback>
                        </>
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        htmlFor={`witnessor.${i}.state`}
                        className="required mb-0"
                      >
                        {clientPlaceholder.state}
                      </Form.Label>
                      <Form.Control
                        className="form-input input-border-radius-unset"
                        type="text"
                        name={`witnessor.${i}.state`}
                        autoComplete="off"
                        {...register(`witnessor.${i}.state`)}
                        isInvalid={!!errors?.witnessor?.[i]?.state}
                        data-testid={`witnessor.${i}.state`}
                        id={`witnessor.${i}.state`}
                        onChange={handleChangeField}
                        disabled
                      />
                      <Form.Control.Feedback
                        data-testid="invalid-feedback"
                        type="invalid"
                      >
                        {errors?.witnessor?.[i]?.state?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        htmlFor={`witnessor.${i}.country`}
                        className="required mb-0"
                      >
                        {clientPlaceholder.country}
                      </Form.Label>
                      <Form.Control
                        className="form-input input-border-radius-unset"
                        type="text"
                        name={`witnessor.${i}.country`}
                        autoComplete="off"
                        {...register(`witnessor.${i}.country`)}
                        isInvalid={!!errors?.witnessor?.[i]?.country}
                        data-testid={`witnessor.${i}.country`}
                        id={`witnessor.${i}.country`}
                        onChange={handleChangeField}
                        disabled
                      />
                      <Form.Control.Feedback
                        data-testid="invalid-feedback"
                        type="invalid"
                      >
                        {errors?.witnessor?.[i]?.country?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6}></Col>
                </Row>
              </div>
              {i === 0 && fields.length > 1 && (
                <>
                  <div className="divider  position-absolute d-flex justify-content-between pb-2">
                    <span className="label-text ps-0 ps-lg-4 ps-md-4 pd-left">
                      Witness 2
                    </span>
                    {((stackCount && stackCount?.DefaulWitness!==null && stackCount?.DefaulWitness === 1) || (
                      (stackHolders && stackHolders?.witness &&  stackHolders?.witness?.length<2)
                    )) && (
                      <span
                        className="delete-icon pe-0 pe-lg-5 pe-md-5 "
                        onClick={() => removeMoreWitnessor(i)}
                        data-testid="remove-witness-button"
                      >
                        <DeleteIcon width={24} height={24} />
                      </span>
                    )}
                  </div>
                  <div className=""></div>
                </>
              )}
            </div>
          );
        })}
        {fields.length === 1 && (
          // ((stackHolders?.executorList && stackHolders?.executorList.length===0) || (!stackHolders?.executorList))  && fields.length === 1 && (
          <Row className="text-align-center">
            <Col lg={4} md={4} sm={6} className="mt-2">
              <Button
                type="button"
                className="custom-button btn-standard btn-update add-executor-button"
                data-testid="addmore-witness-button"
                ref={buttonRef}
                onClick={addMoreWitnessor}
              >
                Add Another Witness
              </Button>
            </Col>
            <Col lg={8} md={8} sm={6} className="mt-4"></Col>
          </Row>
        )}

        <div className="d-flex justify-content-center mt-lg-2">
          <Button
            className="custom-button btn-nobg mx-2 px-5"
            data-testid="cancel-button"
            onClick={onPrevious}
          >
            Back
          </Button>
          <Button
            type="submit"
            className="custom-button btn-standard btn-update mx-2 px-5"
            data-testid="next-witness-info-button"
            disabled={btnDisabled}
            // onClick={nextStep}
          >
            Submit
          </Button>
        </div>
      </Form>
      {(geoCodeLoading || geoCodeLoading2) && <Loader />}
      <ModalPopupType2
        setShowCallback={() => setConfirmModal(false)}
        content={optionalWitValidationMessage}
        showModal={showConfirmModal}
        setYesCallback={() => onConfirm(submittedData)}
      />
    </>
  );
}

export default WitnessInformation;
